"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasNoResults = void 0;
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const hasNoResults = '@guard/hasNoResults';
exports.hasNoResults = hasNoResults;
const guards = {
    /* no results if no appoinment data comes back OR we have no bookable locations (slots mismatch) */
    [hasNoResults]: (_ctx, ev) => !ev.data || (0, isEmpty_1.default)(ev.data) || ev.data.length === 0
};
exports.default = guards;
//# sourceMappingURL=guards.apptTime.js.map